export default __webpack_public_path__ + "assets/front/scss/formulaire.bc9c60ba337db6447f121e24fb890343.css";